<template>
  <div style="display: none">
    <p>You have left this browser idle for 3 second.</p>
    <p>{{ second }} second left</p>
  </div>
</template>
<script>
import { AuthService } from '@/services/auth.service'

export default {
  name: 'IdleModal',
  data: function () {
    return {
      time: 1800000,
      idleModal: false
    }
  },
  computed: {
    second () {
      return this.time / 1000
    }
  },
  created () {
    const timerId = setInterval(() => {
      this.time -= 1000
      if (!this.$store.state.idleVue.isIdle) clearInterval(timerId)

      if (this.time < 1) {
        clearInterval(timerId)
        if (AuthService.hasBearer()) {
          this.$store.commit('toast/NEW', {
            type: 'error',
            message: 'Session Expired'
          })
          AuthService.makeLogout()
        }
      }
    }, 1000)
  }
}
</script>

<style scoped>

</style>
